import React from 'react'
import type { CommentDTO } from '../../api/comments'

type Props = {
  comment: CommentDTO
  onLike: (id: string | number) => void
  onReply: (c: CommentDTO) => void
  onGift?: (c: CommentDTO) => void
  onReport?: (c: CommentDTO) => void
}

export default function CommentItem({ comment, onLike, onReply, onGift, onReport }: Props) {
  const likeCount = (comment.reactions?.like ?? 0) as number
  const liked = comment.my_reaction === 'like'
  const ts = new Date(comment.created_at)
  const time = isNaN(ts.getTime()) ? '' : ts.toLocaleString()

  return (
    <div className="px-3 py-3">
      <div className="flex items-start gap-3">
        {comment.author?.avatar_url ? (
          <img src={comment.author.avatar_url} className="h-9 w-9 rounded-full object-cover" />
        ) : (
          <div className="h-9 w-9 rounded-full bg-white/10" />
        )}
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <div className="font-semibold truncate">{comment.author?.name || 'Anonymous'}</div>
            {comment.author?.handle && <div className="text-xs text-white/60 truncate">{comment.author.handle}</div>}
            <div className="ml-auto text-xs text-white/50">{time}</div>
          </div>
          <div className="mt-1 text-white/95 whitespace-pre-wrap prose prose-invert max-w-none">{comment.body}</div>
          <div className="mt-2 flex items-center gap-4 text-sm">
            <button onClick={() => onLike(comment.id)} className="flex items-center gap-1 hover:opacity-90">
              <i className={`fa-solid fa-heart ${liked ? 'text-red-500' : 'text-white/85'}`} />
              <span className="text-white/80">{likeCount}</span>
            </button>
            <button onClick={() => onReply(comment)} className="flex items-center gap-1 text-white/85 hover:opacity-90">
              <i className="fa-solid fa-reply" />
              <span>Reply</span>
            </button>
            {onGift && (
              <button onClick={() => onGift(comment)} className="flex items-center gap-1 text-fuchsia-400 hover:opacity-90">
                <i className="fa-solid fa-gift" />
                <span>Gift</span>
              </button>
            )}
            {onReport && (
              <button onClick={() => onReport(comment)} className="flex items-center gap-1 text-white/70 hover:text-white">
                <i className="fa-solid fa-flag" />
                <span>Report</span>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
